/**
 * Gets the facet name in a normalized format.
 *
 * @param facetName the name of the facet
 * @param convertCase the conversion function, I.e.: kebabCaseToCamelCase, camelCaseToKebabCase
 */
export function getNormalizedFacetName(
  facetName: string,
  convertCase: (name: string) => string
) {
  let normalizedFacetName = facetName
  // Don't normalize metadata facet names as they don't conform to a specific format.
  if (!isApplicationMetadataFacet(facetName)) {
    normalizedFacetName = convertCase(facetName)
  }
  return normalizedFacetName
}

export function isApplicationMetadataFacet(name: string) {
  return name.includes('application-metadata')
}
